import React, { useState, useEffect } from 'react';
import {withTranslation} from 'react-i18next';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Select from 'react-select';
import Pagination from '../../components/Pagination'
import { useHistory, useLocation } from 'react-router-dom';
import {CURRENCIES} from '../../constants';
import jobService from '../../services/JobService';
import {HTTP_RESPONSE_STATUS} from '../../constants/http';
import JobSearchResultList from './components/JobSearchResultList';
import JobsList from './components/JobList';
import queryString from 'query-string';
const options = [
	{ value: 'chocolate', label: 'Chocolate' },
	{ value: 'strawberry', label: 'Strawberry' },
	{ value: 'vanilla', label: 'Vanilla' }
]
const JOB_SORTS = [
	{ id: 1, name: 'sort_relevance' },
	{ id: 2, name: 'sort_newest' },
	{ id: 3, name: 'sort_oldest' }
]

const JobsFinder = ({t, match}) => {
	const history = useHistory();
	const search = queryString.parse(useLocation().search);

	const [showModal, setShowModal] = useState(false);
	//const [values, setValues] = useState({});
	const [jobs,setJobs] = useState([]);
	const [errors, setErrors] = useState({});
	const [totalPages, setTotalPages] = useState(5);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);

	const [sort, setSort] = useState({id: 1, name: "sort_relevance"});
	const [searchParams, setSearchParams] = useState({currencyCode: null, page: currentPage, size: pageSize, 
		location: search.location, 
		q: search.q});

	const [types, setTypes] = useState([]);
	const [majors, setMajors] = useState([]);
	const [levels, setLevels] = useState([]);
	const [degrees, setDegrees] = useState([]);
	const [positions, setPositions] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	//Email Notification Modal
	const [showModalEmailNotification, setShowModalEmailNotification] = useState(false);

	useEffect(() => {
		//searchParams.location = search.location;
		//searchParams.q = search.q;
		setSearchParams({...searchParams});///, location: search.location, keywords: search.keywords});
		jobService.searchAndCount(searchParams)
        .then(resObj => {
            setIsLoading(false);
            if (resObj.status === HTTP_RESPONSE_STATUS.OK) {
                if (resObj.data) {
                    setJobs([...resObj.data.result]);
                    setCurrentPage(resObj.data.page);
                    setPageSize(resObj.data.size);
                    setTotalPages(Math.ceil(resObj.data.total / resObj.data.size));
                } else {
                    setJobs([]);
                    setCurrentPage(1);
                    setTotalPages(0);
                }
            }else {
				setJobs([]);
                setCurrentPage(1);
                setTotalPages(0);
			}
        })
        .catch(err => {
            setJobs([]);
            setCurrentPage(1);
            setTotalPages(0);
            setIsLoading(false);
		});
		
		jobService.getAllTypes()
          .then(response=> {
            if (response.status === HTTP_RESPONSE_STATUS.OK) {
				setTypes(response.data);
            }
          }).catch(err => {

		});
		jobService.getAllMajors()
          .then(response=> {
            if (response.status === HTTP_RESPONSE_STATUS.OK) {
				setMajors(response.data);
            }
          }).catch(err => {

		});
		jobService.getAllLevels()
          .then(response=> {
            if (response.status === HTTP_RESPONSE_STATUS.OK) {
				setLevels(response.data);
            }
          }).catch(err => {

		});
		jobService.getAllDegrees()
          .then(response=> {
            if (response.status === HTTP_RESPONSE_STATUS.OK) {
				setDegrees(response.data);
            }
          }).catch(err => {

		});
		jobService.getAllPositions()
          .then(response=> {
            if (response.status === HTTP_RESPONSE_STATUS.OK) {
				setPositions(response.data);
            }
          }).catch(err => {

		});
		///Call search and count function
	},[]);
	const handleChangPage = (e, page) => {
		e.preventDefault();
		setCurrentPage(page);
		history.push("/jobs/finder?" + queryString.stringify(
			{...searchParams, page: page, size: pageSize},
			{
				skipEmptyString: true,
				skipNull: true
			}
		));
        ///Call
        /*let query = queryString.stringify({...searchParams, page: page, size: pageSize},
            {
                skipEmptyString: true,
                skipNull: true
            });*/
        setIsLoading(true);
        jobService.search({...searchParams, page: page, size: pageSize})
        .then(resObj => {
            setIsLoading(false);
            if (resObj.status === HTTP_RESPONSE_STATUS.OK) {
                if (resObj.data) {
                    setJobs(resObj.data);
                } else {
                    setJobs([]);
                }
            }
        })
        .catch(err => {
            setJobs([]);
            setIsLoading(false);
        });
	};
	const handleChangeFields = (e) => {
        searchParams[e.target.name] = e.target.value;
        setSearchParams({...searchParams});
    };
	const handleClose = () => {
		setShowModal(false);
	};
	const handleChangeSort = (item) => {
		searchParams['sort'] = item.id;
		setSearchParams({...searchParams});
		setSort({...item});
		history.push("/jobs/finder?" + queryString.stringify(
			{...searchParams, page: currentPage, size: pageSize},
			{
				skipEmptyString: true,
				skipNull: true
			}
		));
        ///Call
        /*let query = queryString.stringify({...searchParams, page: page, size: pageSize},
            {
                skipEmptyString: true,
                skipNull: true
            });*/
        setIsLoading(true);
        jobService.search({...searchParams, page: currentPage, size: pageSize})
        .then(resObj => {
            setIsLoading(false);
            if (resObj.status === HTTP_RESPONSE_STATUS.OK) {
                if (resObj.data) {
                    setJobs(resObj.data);
                } else {
                    setJobs([]);
                }
            }
        })
        .catch(err => {
            setJobs([]);
            setIsLoading(false);
        });
	};
	const handleSearch = () => {
		setIsLoading(true);
		setShowModal(false)
		setSearchParams({...searchParams, page: 1});///, location: search.location, keywords: search.keywords});
		jobService.searchAndCount(searchParams)
        .then(resObj => {
            setIsLoading(false);
            if (resObj.status === HTTP_RESPONSE_STATUS.OK) {
                if (resObj.data) {
                    setJobs([...resObj.data.result]);
                    setCurrentPage(resObj.data.page);
                    setPageSize(resObj.data.size);
                    setTotalPages(Math.ceil(resObj.data.total / resObj.data.size));
                } else {
                    setJobs([]);
                    setCurrentPage(1);
                    setTotalPages(0);
                }
            }
        })
        .catch(err => {
            setJobs([]);
            setCurrentPage(1);
            setTotalPages(0);
            setIsLoading(false);
		});
		history.push("/jobs/finder?" + queryString.stringify(
			searchParams,
			{
				skipEmptyString: true,
				skipNull: true
			}
		));
	};
	const hanldeEnterKeyDown = (e) => {
		if (e.key === 'Enter') {
			setIsLoading(true);
			setSearchParams({...searchParams, page: 1});///, location: search.location, keywords: search.keywords});
			jobService.searchAndCount(searchParams)
			.then(resObj => {
				setIsLoading(false);
				if (resObj.status === HTTP_RESPONSE_STATUS.OK) {
					if (resObj.data) {
						setJobs([...resObj.data.result]);
						setCurrentPage(resObj.data.page);
						setPageSize(resObj.data.size);
						setTotalPages(Math.ceil(resObj.data.total / resObj.data.size));
					} else {
						setJobs([]);
						setCurrentPage(1);
						setTotalPages(0);
					}
				}
			})
			.catch(err => {
				setJobs([]);
				setCurrentPage(1);
				setTotalPages(0);
				setIsLoading(false);
			});
			history.push("/jobs/finder?" + queryString.stringify(
				searchParams,
				{
					skipEmptyString: true,
					skipNull: true
				}
			));
		}
	};
	const handleEmailNotification = (e) => {
		//window.alert(e.target.checked);
		setShowModalEmailNotification(e.target.checked);

	};
	const handleEmailNotificationClose = (e) => {
		setShowModalEmailNotification(false);
	};
    return (
        <>
            <div className="header_wrapper">
            </div>
			<Modal show={showModalEmailNotification} onHide={handleEmailNotificationClose}>
				<Modal.Header closeButton>
					<Modal.Title>{t('jobs_email_notifications')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form>
					</Form>
				</Modal.Body>
			</Modal>
			<Modal size="lg" show={showModal} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>{t('filter')}</Modal.Title>
					<Button variant="link">{t('reset')}</Button>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Row>
							<Col md={12} xl={4}>
								<Form.Group controlId="majorId">
									<Form.Label>{t('job_major')}</Form.Label>
									<Select placeholder={t('select_all')} options={majors.map(item => { return {value: item.id, label: item.name}})} name="marjor"/>
								</Form.Group>
							</Col>
							<Col md={12} xl={4}>
								<Form.Group controlId="level">
									<Form.Label>{t('level')}</Form.Label>
									<Select placeholder={t('select_all')} options={levels.map(item => { return {value: item.id, label: item.name}})} name="level" />
								</Form.Group>
							</Col>
							<Col md={12} xl={4}>
								<Form.Group controlId="type">
									<Form.Label>{t('job_type')}</Form.Label>
									<Select placeholder={t('select_all')} options={types.map(item => { return {value: item.id, label: item.name}})} name="type" />
								</Form.Group>
							</Col>
							<Col md={12} xl={4}>
								<Form.Group controlId="level">
									<Form.Label>{t('job_position')}</Form.Label>
									<Select placeholder={t('select_all')} options={positions.map(item => { return {value: item.id, label: item.name}})} name="position" />
								</Form.Group>
							</Col>
							<Col md={12} xl={8}>
								<Form.Group controlId="skills">
									<Form.Label>{t('job_skills')}</Form.Label>
									<Select placeholder={t('select_all')} options={options} isMulti/>
								</Form.Group>
							</Col>
						</Row>
						<Row>
							<Col md={12} xl={4}>
								<Form.Group controlId="salary">
									<Form.Label>{t('salary_from')}</Form.Label>
									<Form.Control type="number" placeholder={t('salary_from')} name="salaryFrom" onChange={handleChangeFields} min={1} step="100" value={searchParams.salaryFrom}/>
								</Form.Group>
							</Col>
							<Col md={12} xl={4}>
								<Form.Group controlId="salary">
									<Form.Label>{t('salary_to')}</Form.Label>
									<Form.Control type="number" placeholder={t('salary_to')} name="salaryTo" onChange={handleChangeFields} min={1} step="100" value={searchParams.salaryTo}/>
								</Form.Group>
							</Col>
							<Col md={12} xl={4}>
								<Form.Group controlId="currencyCode">
									<Form.Label>{t('currency')}</Form.Label>
									<Form.Control as="select" name="currencyCode" onChange={handleChangeFields} value={searchParams.currencyCode}>
									{
										CURRENCIES.map((item, index) => {
											return (
											<option value={item.code} key={index}>{item.name}</option>
											)
										})
                                	}
									</Form.Control>					
								</Form.Group>
							</Col>
						</Row>
						
						
					</Form>
				</Modal.Body>
				<Modal.Footer>
				<Button variant="secondary" onClick={handleClose}>
					{t('cancel')}
				</Button>
				<Button variant="primary" onClick={handleSearch}>
					{t('search')}
				</Button>
				</Modal.Footer>
			</Modal>
            <div className="full-page-container" style={{height: "auto"}}>
                <div className="full-page-sidebar">
                    <div className="full-page-sidebar-inner" data-simplebar="init" style={{height: "auto"}}>
                    <div className="simplebar-scroll-content" style={{paddingRight: "20px", marginBottom: "-20px"}}>
                        <div className="simplebar-content" style={{paddingBottom: "20px"}}>
			<div className="sidebar-container">
				
				<div class="sidebar-widget">
					<h3>{t('location')}</h3>
					<div className="input-with-icon">
						<div id="autocomplete-container">
							<input id="autocomplete-input" name="location" value={searchParams.location} onChange={handleChangeFields} className="input-search" type="text" placeholder={t('job_location')} onKeyDown={hanldeEnterKeyDown}/>
						</div>
						<i className="fa fa-map-marker" aria-hidden="true"></i>
					</div>
				</div>
				<div className="sidebar-widget">
					<h3>{t('keywords')}</h3>
					<div className="keywords-container">
						<div className="keyword-input-container">
							<input type="text" name="q" value={searchParams.q}  onChange={handleChangeFields} class="input-search keyword-input" placeholder={t('job_search_placeholder')} onKeyDown={hanldeEnterKeyDown}/>
						</div>
						<div className="keywords-list" style={{height: "auto"}}></div>
					</div>
				</div>
				{/*<div class="sidebar-widget">
					<h3>Categories</h3>
					<div class="keywords-container">
						<div class="keyword-input-container" style={{zIndex: "120"}}>
							<Select options={options} isMulti style={{borderCode: "white"}}/>
						</div>
					</div>
				</div>*/}
			
				{/*
				<div class="sidebar-widget">
					<div class="keywords-container">
						<div class="keyword-input-container">
							<input type="text" class="input-search keyword-input" disabled placeholder={t('job_finder_add_more')}/>
							<button class="keyword-input-button ripple-effect" onClick={() => setShowModal(true)}><i class="fa fa-plus" aria-hidden="true"></i></button>
						</div>
					</div>
				</div>
				*/}
				
				
				
				{/*<div class="sidebar-widget">
					<h3>Job Type</h3>

					<div class="switches-list">
						
					</div>

				</div>

				<div class="sidebar-widget">
					<h3>Salary</h3>
					<div class="margin-top-55"></div>

				</div>

				<div class="sidebar-widget">
					<h3>Tags</h3>

					<div class="tags-container">
						
					</div>
					<div class="clearfix"></div>
				</div>*/}

			</div>
			<div class="sidebar-search-button-container">
				<button className="button button_4" onClick={handleSearch}>{t('search')}</button>
			</div>

		</div></div>
                    </div>
                </div>
                {/*<div class="full-page-content-container" data-simplebar="init" style={{height: "678px"}}>
                <div class="simplebar-scroll-content" style={{paddingRight: "20px", marginBottom: "-20px"}}>*/}
                <div class="full-page-content-container">
                <div class="simplebar-scroll-content">
                    <div class="simplebar-content" style={{paddingBottom: "20px"}}>
		<div class="full-page-content-inner">

			<h3 class="page-title">{t('search_results')}</h3>

			<div className="notify-box margin-top-15">
				<div className="switch-container">
					<label className="switch"><input type="checkbox" onChange={handleEmailNotification}/><span className="switch-button"></span><span className="switch-text">{t('job_finder_turn_on_email_alert')}</span></label>
				</div>
				<div className="sort-by">
					<span>{t('sort') + ":"} &nbsp;</span>
					<Dropdown>
						<Dropdown.Toggle  className="p-0" variant="primitive" id="dropdown-basic">
							{t(sort.name)}
						</Dropdown.Toggle>
						<Dropdown.Menu>
							{
								JOB_SORTS.map ((item, id) => (
									<Dropdown.Item key={id} onClick={ (e) => handleChangeSort(item)}>{t(item.name)}</Dropdown.Item>
								))
							}
							{/*<Dropdown.Item href="#/action-1">Action</Dropdown.Item>
							<Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
							<Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
						*/}
						</Dropdown.Menu>
					</Dropdown>
				</div>
			</div>

			<div className="listings-container compact-list-layout margin-top-35">
				
				{/*<JobSearchResultList items = {jobs} />*/}
				<JobsList items={jobs}/>


			</div>

			<div className="clearfix"></div>
			<div className="pagination-container margin-top-20 margin-bottom-20">
				{totalPages > 1 && <Pagination limit={2} onPageChanged={handleChangPage} activePage={currentPage} pages={totalPages}/> }
			</div>
			<div className="clearfix"></div>
			
		
		</div>
		
	</div></div>
                </div>
            </div>
        </>
    );
};
export default withTranslation()(JobsFinder)


/*<div class="sidebar-widget mb-1">
					<h3>Category</h3>
					<div class="btn-group bootstrap-select show-tick default"><button type="button" class="btn dropdown-toggle bs-placeholder btn-default" data-toggle="dropdown" role="button" title="All Categories"><span class="filter-option pull-left">All Categories</span>&nbsp;<span class="bs-caret"><span class="caret"></span></span></button><div class="dropdown-menu open" role="combobox"><ul class="dropdown-menu inner" role="listbox" aria-expanded="false"><li data-original-index="0"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Admin Support</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="1"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Customer Service</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="2"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Data Analytics</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="3"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Design &amp; Creative</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="4"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Legal</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="5"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Software Developing</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="6"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">IT &amp; Networking</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="7"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Writing</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="8"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Translation</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="9"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Sales &amp; Marketing</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li></ul></div><select class="selectpicker default" multiple="" data-selected-text-format="count" data-size="7" title="All Categories" tabindex="-98">
						<option>Admin Support</option>
						<option>Customer Service</option>
						<option>Data Analytics</option>
						<option>Design &amp; Creative</option>
						<option>Legal</option>
						<option>Software Developing</option>
						<option>IT &amp; Networking</option>
						<option>Writing</option>
						<option>Translation</option>
						<option>Sales &amp; Marketing</option>
					</select></div>
					
					<DropdownButton
						className="bootstrap-select show-tick default"
						as={ButtonGroup}
						drop="down"
						title={'all_categories'}
						bsPrefix="bs-placeholder btn-default"
					>
						<Dropdown.Item eventKey="1">Action</Dropdown.Item>
						<Dropdown.Item eventKey="2">Another action</Dropdown.Item>
						<Dropdown.Item eventKey="3">Something else here</Dropdown.Item>
						<Dropdown.Divider />
						<Dropdown.Item eventKey="4">Separated link</Dropdown.Item>
					</DropdownButton>
				</div>*/